/*
 * Copyright (c) 2019 LNBIG.com
 * All rights reserved.
 */

import glue from "../CommandGlue";
import Vue from 'vue'
import merge from 'deepmerge'
import dbg from "debug";
const debug = dbg('lnbig:store:openChannel')

export default function (obj, namespace, captchaName) {
    return merge(
        obj,
        {
            state: {
                token: null,       // token from captcha v3
                reCaptchaV3: {
                    executed: false,        // Если хотя бы раз исполнялась - true
                    ok: false,              // Если true - прошла проверку и это человек
                    error: null,            // Если не прошла проверку - текст ошибки
                },
                reCaptchaV2: {
                    executed: false,        // Если хотя бы раз исполнялась - true
                    ok: false,              // Если true - прошла проверку и это человек
                    error: null,            // Если не прошла проверку - текст ошибки
                },
                reCaptchaV3Promise: null,
                reCaptchaV2Promise: null,
            },
            mutations: {
                setReCaptchaV3Promise(state, promise) {
                    state.reCaptchaV3Promise = promise
                },
                setReCaptchaV2Promise(state, promise) {
                    state.reCaptchaV2Promise = promise
                },
                resetReCaptchaV3(state) {
                    state.reCaptchaV3.error = null
                    state.reCaptchaV3.executed = false
                    state.reCaptchaV3.ok = false
                },
                cmdRecaptchaV3(state, message) {
                    glue.find(
                        'cmdRecaptchaV3',
                        message,
                        (message) => {
                            debug(`cmdRecaptchaV3 (${namespace}/${captchaName}) result: %o`, message);
                            state.reCaptchaV3.executed = true
                            debug('cmdRecaptchaV3, NODE_ENV=%s', process.env.NODE_ENV)
                            return state.reCaptchaV3.ok = message.result
                        }
                    )
                },
                reCapatchaV3Error(state, error) {
                    state.reCaptchaV3.error = error
                    state.reCaptchaV3.executed = true
                    state.reCaptchaV3.ok = false
                },

                resetReCaptchaV2(state) {
                    state.reCaptchaV2.error = null
                    state.reCaptchaV2.executed = false
                    state.reCaptchaV2.ok = false
                },
                cmdRecaptchaV2(state, message) {
                    glue.find(
                        'cmdRecaptchaV2',
                        message,
                        (message) => {
                            debug(`cmdRecaptchaV2 (${namespace}/${captchaName}) result: %o`, message);
                            state.reCaptchaV2.executed = true;
                            return state.reCaptchaV2.ok = message.result
                        }
                    )
                },
                reCapatchaV2Error(state, error) {
                    state.reCaptchaV2.error = error
                    state.reCaptchaV2.executed = true
                    state.reCaptchaV2.ok = false
                },
            },

            actions: {
                // Проверка капчи v3
                async actRecaptchaV3({ state, rootState, commit }) {
                    // С какой следующей командой связываем
                    try {
                        commit('resetReCaptchaV3')
                        debug('actRecaptchaV3 (%s): делаем запрос на получение token', captchaName)
                        await Vue.prototype.$recaptchaLoaded()
                        let token = await Vue.prototype.$recaptcha(captchaName)
                        debug('actRecaptchaV3 (%s): token получен: %s', captchaName, token)
                        return glue.add(
                            (uuid) => {
                                rootState.webSocket.sendObj({
                                    command: 'cmdRecaptchaV3',
                                    namespace,
                                    token,
                                    uuid
                                });

                                debug(`Послали команду cmdRecaptchaV3 (${namespace}/${captchaName}) на сервер, token: ${token}`)
                            },
                            'cmdRecaptchaV3'
                        ).catch( e => { commit('reCapatchaV3Error', e.message) } )
                    }
                    catch (e) {
                        console.log('actRecaptchaV3, error: %s', e.message)
                        return null
                    }
                },
                // Проверка капчи v2
                async actRecaptchaV2({ state, rootState, commit }, component) {
                    // С какой следующей командой связываем
                    try {
                        commit('resetReCaptchaV2')
                        debug('actRecaptchaV2: делаем запрос на получение token')
                        let token = await component.getTokenRecaptchaV2()
                        debug('actRecaptchaV2: token получен: %s', token)
                        return glue.add(
                            (uuid) => {
                                rootState.webSocket.sendObj({
                                    command: 'cmdRecaptchaV2',
                                    namespace,
                                    token,
                                    uuid
                                });

                                debug(`Послали команду cmdRecaptchaV2 (${namespace}) на сервер, token: ${token}`)
                            },
                            'cmdRecaptchaV2'
                        ).catch( e => { commit('reCapatchaV2Error', e.message) } )
                    }
                    catch (e) {
                        console.log('actRecaptchaV2, error: %s', e.message)
                        return null
                    }
                },
                async checkHelloAndRecaptcha({state, rootState, dispatch, commit}, component) {
                    if (! rootState.webSocket && rootState.webSocketError) {
                        throw new Error(rootState.webSocketError)
                    }
                    if (! rootState.wsConnectPromise)
                        throw new Error("No websocket connection")
                    await rootState.wsConnectPromise
                    await rootState.helloPromise

                    if (! state.reCaptchaV3Promise)
                        commit('setReCaptchaV3Promise', dispatch('actRecaptchaV3'))

                    if (! await state.reCaptchaV3Promise) {
                        if (! state.reCaptchaV2Promise)
                            commit('setReCaptchaV2Promise', dispatch('actRecaptchaV2', component))
                        if ( ! await state.reCaptchaV2Promise)
                            throw new Error("You defined as bot. Sorry but you cannot open a channel here")
                    }
                }
            }
        }
    )
}
